"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FontAwesome = /** @class */ (function (_super) {
    __extends(FontAwesome, _super);
    function FontAwesome(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { prefix: "fas" };
        if (_this.props.kind) {
            if (_this.props.kind === "solid") {
                _this.state = { prefix: "fas" };
            }
            if (_this.props.kind === "regular") {
                _this.state = { prefix: "far" };
            }
            if (_this.props.kind === "bold") {
                _this.state = { prefix: "fab" };
            }
        }
        return _this;
    }
    FontAwesome.prototype.getRendreObject = function () {
        var ml = 0;
        var mr = 0;
        if (this.props.left) {
            mr = 5;
        }
        if (this.props.right) {
            ml = 5;
        }
        var _tmp = {
            marginLeft: ml + "px",
            marginRight: mr + "px"
        };
        return React.createElement("i", { style: _tmp, className: this.state.prefix + " fa-" + this.props.icon });
    };
    FontAwesome.prototype.render = function () {
        return this.getRendreObject();
    };
    return FontAwesome;
}(React.Component));
exports.default = FontAwesome;
exports.FA = FontAwesome;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/icons/FontAwesome.tsx
// module id = 21
// module chunks = 0